import { limeApiFetch } from "../utils/api";

export const getCurrentUserPermissions = async (auth: any) => {
    const response = await limeApiFetch(`permissions/CurrentUser`, 'GET', auth);
    let data = await response.json();
    return data.generalPermissions;
};